import { render } from "./createCluster.vue?vue&type=template&id=2e213279&scoped=true"
import script from "./createCluster.vue?vue&type=script&lang=js"
export * from "./createCluster.vue?vue&type=script&lang=js"

import "./createCluster.vue?vue&type=style&index=0&id=2e213279&scoped=true&lang=css"

import exportComponent from "/home/quantum/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e213279"]])

export default __exports__